import Vue from 'vue';
import '@/assets/stylesheets/v2/_bundle-card.scss';
export default Vue.extend({
    props: {
        bundle: {
            type: Object,
            required: true,
        },
        dataCy: {
            type: String,
            required: false,
        },
    },
    render(createElement) {
        return createElement('v-card', { class: 'bundle-card mr-3' }, [
            createElement('v-card-title', { class: 'header' }, [
                createElement('div', { class: 'align-center' }, [
                    createElement('div', [
                        createElement('span', { class: 'subtext' }, this.bundle.name === 'Shopify Bundle'
                            ? 'For Shopify Store Owners:'
                            : 'For Merchants Without a Shopify Store:'),
                    ]),
                    createElement('div', { class: '' }, [
                        createElement('span', { class: 'name' }, this.bundle.name),
                    ]),
                ]),
            ]),
            createElement('v-card-title', { class: 'content' }, [
                createElement('div', [
                    createElement('span', { class: 'description' }, this.bundle.description),
                ]),
            ]),
            createElement('v-card-actions', { class: 'actions' }, [
                createElement('v-btn', {
                    class: this.bundle.name === 'Shopify Bundle' ? 'create text-capitalize' : 'hidden-button',
                    attrs: { 'data-cy': this.dataCy ? `${this.dataCy}-connect-shopify` : undefined },
                    on: { click: () => this.$emit('select', this.bundle.uuid) },
                }, 'Connect Shopify Store'),
                createElement('v-btn', {
                    class: this.bundle.name === 'Shopify Bundle'
                        ? 'hidden-button'
                        : 'create-ecommerce text-capitalize',
                    attrs: { 'data-cy': this.dataCy ? `${this.dataCy}-create-in-app-store` : undefined },
                    on: { click: () => this.$emit('select', this.bundle.uuid) },
                }, ' Create Your In-App Store'),
            ]),
        ]);
    },
});
